// Constants - Functions
import { protocols } from "../../../../config/constants";
import { importImages } from "../../../../config/functions";

export const GetWebFullBodyProtocolData = (protocolId) => {
  const protocolImg = importImages(
    require.context("../../../../assets/images/protocols/reports/web/fullBody", false, /\.(png|jpe?g|svg)$/)
  );

  const protocolsData = {
    [protocols.web.fullBody.TWISTER_BUDDY.id]: {
      img: protocolImg["./twister_buddy.png"],
      imgResponsive: protocolImg["./twister_buddy_responsive.png"],
      name: "uppercaseProtocols_twisterBuddy",
      description: "protocols_twisterBuddyDescription",
      video: "protocols_twisterBuddyVideo",
    },
    [protocols.web.fullBody.COSTUME_PARTY.id]: {
      img: protocolImg["./costume_party.png"],
      imgResponsive: protocolImg["./costume_party_responsive.png"],
      name: "uppercaseProtocols_costumeParty",
      description: "protocols_costumePartyDescription",
      video: "protocols_costumePartyVideo",
    },
    [protocols.web.fullBody.GENTLE_GIANT.id]: {
      img: protocolImg["./gentle_giant.png"],
      imgResponsive: protocolImg["./gentle_giant_responsive.png"],
      name: "uppercaseProtocols_gentleGiant",
      description: "protocols_gentleGiantDescription",
      video: "protocols_gentleGiantVideo",
    },
  };

  return protocolsData[Number(protocolId)];
};
